import React, { useEffect } from "react";

import Main from '../components/About/Main'
import Why from "../components/About/Why";
import Mission from "../components/About/Mission";
import Social from "../components/About/Social";
import KeyElements from "../components/About/KeyElements";
import Raw from "../components/About/Raw";
import Contacts from "../components/About/Contacts";

function AboutUs () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#1D1D1D] relative overflow-hidden">
            <Main/>
            <Why/>
            <Mission/>
            <Social/>
            <KeyElements/>
            <Raw/>
            <Contacts/>
        </div>
    );
}

export default AboutUs;